import { Card, Row } from "antd"
import Heading from "../../../../component/common/Heading"
import CRUDComponent from "../../../../component/common/CRUD-Component"
import CONSTANTS from "../../../../util/constant/CONSTANTS"

const MedicineTab = () => {
    return (
        <>
            <Card className="my-5">
                <Heading>Medicine Registry</Heading>
                <Row>
                    <CRUDComponent

                        GET={{
                            API: CONSTANTS.API.Medicine.medicine.getAll,

                            DataModifier: (res, API, Setrefresh) => {
                                // console.log(res, "GET ALL ABCD");
                                return res?.map(data => {
                                    return {
                                        ...data,
                                        no: `M${data?.id.toString().padStart(7, "0")}`,
                                    }
                                })
                            },
                            column: CONSTANTS.TABLE.MEDICINE_LIST,
                            // column: deviceTypeId[1] === '1' ? CONSTANTS.TABLE.DEVICE_1 : CONSTANTS.TABLE.DEVICE_2,
                        }}
                        UPDATE={{
                            API: CONSTANTS.API.Medicine.medicine.update,
                            message: "Updated Medicine Registry successfully",
                            modaltitle: "Update Medicine Registry Device",
                            modalFields: CONSTANTS.FORM_FIELD.MEDICINE_MODAL,
                            // payloadModifier: (res) => {
                            //     let payload = {}
                            //     Object.keys(res)?.forEach(ele => {
                            //         if (res[ele]) {
                            //             payload = {
                            //                 ...payload,
                            //                 [ele]: res[ele]
                            //             }
                            //         }
                            //     })
                            //     return payload
                            // },
                        }}
                        CREATE={{
                            API: CONSTANTS.API.Medicine.medicine.add,
                            message: "Created Medicine Registry successfully",
                            modaltitle: "Add Medicine Registry",
                            modalFields: CONSTANTS.FORM_FIELD.MEDICINE_MODAL,
                            // payloadModifier: (res) => {
                            //     return {
                            //         ...res,
                            //         animalType: 'D',
                            //     }
                            // },
                        }}
                        DELETE={{
                            API: CONSTANTS.API.Medicine.medicine.delete,
                            message: "Deleted Medicine Registry Successfully",
                        }}
                        isSearch={true}

                    />
                </Row>
            </Card>
        </>
    )
}
export default MedicineTab